const styles = {
  wrapperForAutocompleteSuggestions: {
    textAlign: 'left',
    maxWidth: 400,
  },
};

export default styles;
